export default "__VITE_ASSET__DDKKhXjS__"